import logo from './logo.svg';
import './App.css';
import { useState, useEffect, useRef } from "react";


function App() {
  
    const [dataResult, setData] = useState([]);;
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState(null);
    const inputRef = useRef(null);
    const queryParameters = new URLSearchParams(window.location.search);
  const bills = queryParameters.get("bills");
    
    
  useEffect(() => {
    
    if (bills !== undefined && bills !== null) {
      document.getElementById("tracuu").click();
    }
    
  }, []); // <-- empty array means 'run once'
  
  function handleSubmit(e) {
    console.log('clicked');
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    /*useEffect(() => {
      fetch(`https://gw.vietlight-express.com/tracking/v1/multiple-tracking`, { method: form.method, body: formData })
       .then((response) => response.json())
      .then((actualData) => console.log(actualData));
     }, []);*/
    /*fetch(`https://gw.vietlight-express.com/tracking/v1/multiple-tracking`, { method: form.method, body: formData });*/
    console.log(inputRef.current.value);
    fetch('https://gw.vietlight-express.com/tracking/v1/multiple-tracking?' + new URLSearchParams({
        bills: inputRef.current.value,
    })).then((response) => response.json()).then((data) => {
			if (Array.isArray(data.data)) {
              	console.log('This is your data', data);
                setData(data.data);
                console.log(dataResult);
              	setError(false);
            } else {
              console.log("error");
              console.log(data.errors.message);
              setError(data.errors.message);
            }
       });
    
  }
	
   
  return (
    <div className="App">
    	<header><div>ABC</div></header>
    <div class="elementor-widget-container">
			                 
        
    
      <div class="elementor-container elementor-column-gap-default search-container" >
                      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6aeb8d20" data-id="6aeb8d20" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                                  <div class="elementor-element elementor-element-28e6cafc elementor-widget elementor-widget-shortcode" data-id="28e6cafc" data-element_type="widget" data-widget_type="shortcode.default">
                  <div class="elementor-widget-container">
    
    <div class="team-area de-padding">
            <div class="container">
                                <div class="row">
                    <div class="col-xl-8 offset-xl-2">
                        <div class="site-title text-center">
                                                        <span class="hero-sub-title mb-20">
                                <span class="hero-line"></span>
                                TRACKING    </span>
                                                                                    <h2 class="heading-1 mb-20">
                                Check Rates Quickly                            </h2>
                            <p class="mb-0">With simple steps, you can easily search for shipping rates to your desired destination on the Vietlight Express website.</p>
                                                    </div>
                    </div>
                </div>
                                <div class="team-wpr grid-3">
                                    </div>
            </div>
        </div>
            		</div>
    
                      <div class="elementor-shortcode">
  <div class="wpcf7 no-js" id="wpcf7-f1002-p1190-o1" lang="vi" dir="ltr">
  <div class="screen-reader-response"><p role="status" aria-live="polite" aria-atomic="true"></p> <ul></ul></div>
  <form id="trackingForm" action="/tracking" method="get" class="wpcf7-form init" aria-label="Form lin h" novalidate="novalidate" data-status="init" onSubmit={handleSubmit}>
  <div class="form-track-contai">
      <div class="content-track">
          <div class="intput-track">
              <div class="intrack">
                  <p><span class="wpcf7-form-control-wrap" data-name="mavandon">
                    <input ref={inputRef} class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required inputtrack" placeholder="Nhập mã vận đơn" type="text" name="bills" defaultValue={bills} /></span>
                  </p>
              </div>
              <div class="subtrack">
                  <p><input class="wpcf7-form-control wpcf7-submit has-spinner btntrack" id="tracuu" type="submit" value="Tracking" />
                  </p>
              </div>
          </div>
          <p>Enter up to 30 tracking numbers, each separated by a comma. Example: 778356980455, 1ZY52E360433363402, AWB162346</p>
          <p>For any inquiries, please contact our hotline: <a href="tel:+0842743777448">(+084)274 3777448</a> or Email: <a href="mailto:info@vietlightgroup.com">info@vietlightgroup.com</a>
          </p>
      </div>
  </div><div class="wpcf7-response-output" aria-hidden="true"></div>
  </form>
  </div>
  </div>
                  </div>
                  </div>
                      </div>
		</div>
							</div>

{!error ? "" :
<div class="form-track-contai"><div class="content-track"><p>{error}</p></div></div>
}
{!dataResult ? "No data received" : dataResult.map( d => (
	<div class=" w-10/12  pt-5 max-md:w-11/12 result-container ">
          <div class="flex w-full flex-col items-center justify-center">
            <div class="mt-4 flex w-full flex-col rounded-[12px] bg-white p-2 shadow-2xl">
              <div class="flex w-full items-center">
                <p class="text-20 font-medium text-Gray_4">Tracking # <span class="text-black">{d.trackingAwb && d.trackingAwb !== "" ? d.trackingAwb : d.vietlightAwb }</span></p>
                <span class="ant-tag ant-tag-success ant-tag-borderless ml-2 css-k7429z"><p class="font-medium">{d.web_status}</p></span>
				<a target="_blank" href="/tra-van-don.html?bill=123"></a>
			  </div>
			<div class="grid w-full grid-cols-2 gap-4 max-md:grid-cols-1">
  <div class="col-span-1">
    <div class="grid grid-cols-2 gap-4">
    	<div class="col-span-1">
          	<p class="text-15 font-medium text-Gray_4">Place of sending</p>
			<div class="flex items-center justify-start font-medium">
				<img src="https://vietlight.washinengine.com/wp-content/uploads/2024/02/user.svg" />
  				<p class="text-14">*****</p>
			</div>
			<div class="flex items-center justify-start font-medium">
    			<img src="https://vietlight.washinengine.com/wp-content/uploads/2024/02/loc.svg" />
      			<p class="text-14">{d.from_address}</p></div>
        		<div class="flex items-center justify-start font-medium">
          		<img src="https://vietlight.washinengine.com/wp-content/uploads/2024/02/phone.svg" />
            	<p class="text-14">***</p>
			</div>
			<p class="text-15 font-medium text-Gray_4">Recipients</p>
			<div class="flex items-center justify-start font-medium">
				<img src="https://vietlight.washinengine.com/wp-content/uploads/2024/02/user.svg" />
    			<p class="text-14">***********</p></div>
      <div class="flex items-center justify-start font-medium">
        <img src="https://vietlight.washinengine.com/wp-content/uploads/2024/02/loc.svg" />
          <p class="text-14">{d.destination}</p></div><div class="flex items-center justify-start font-medium">
            <img src="https://vietlight.washinengine.com/wp-content/uploads/2024/02/phone.svg" />
              <p class="text-14">***</p></div></div><div class="col-span-1 flex justify-start">
<div class="flex h-[180px] w-[30px] flex-col items-center justify-center">
  <div class="flex h-[33px] w-[33px] items-center justify-center">
    <div class="h-[12px] w-[12px]  rounded-[6px] bg-Green_3"></div></div>
      <div class="h-[40px] w-[1px] bg-black"></div>
<div class="flex h-[33px] w-[33px] items-center justify-center"><div class="h-[12px] w-[12px]  rounded-[6px] bg-Green_3 ">
  </div></div>
    <div class="h-[40px] w-[1px] bg-black"></div>
{d.statusCode == "D" ? 
<div class="flex h-[33px] w-[33px] items-center justify-center"><img src="https://vietlight.washinengine.com/wp-content/uploads/2024/02/Untitled-design-1.png" /></div>
: "" }
</div>
  <div class="flex h-[180px] flex-col items-start justify-between px-5 text-black">
    <div class="mt-2 h-[33px]">
      <p class="text-12 font-medium">Picked Up</p></div><div class="h-[40px]"></div>
<div class="h-[33px]"><p class="text-12 font-medium">Being transported</p></div><div class="h-[40px]"></div>
{d.statusCode == "D" ? 
  <div class="h-[33px]"><p class="text-12 font-medium">Delivered</p></div>
 : ""}  
  </div></div></div>
<img src={d.logo_url} style={{width: '50%', margin: "0 auto"}} /></div>
<div class="col-span-1">
  <div class="flex items-start">
    <div class="flex flex-col justify-start">
      <span class="font-medium text-grays">Services: International</span>
</div>
  </div>
      <div class="flex w-full flex-col justify-start">
        <p class="text-15 font-medium text-Gray_4">Transport journey</p><div class="mb-5  rounded-[10px] border border-border">
<div class="ant-table-wrapper css-k7429z">
  <div class="ant-spin-nested-loading css-k7429z">
    <div class="ant-spin-container">
      <div class="ant-table"><div class="ant-table-container">
        <div class="ant-table-content">
          <table><colgroup></colgroup><thead class="ant-table-thead">
<tr style={{backgroundColor: '#03a9f4'}}>
    <th class="ant-table-cell" scope="col" style={{backgroundColor: '#03a9f4'}}>Time</th>
	<th class="ant-table-cell" scope="col">Location & Description</th></tr></thead>
<tbody class="ant-table-tbody">
  {!d.events ? "" : d.events.map( e => (
	<tr class="ant-table-row ant-table-row-level-0">
      <td class="ant-table-cell row-time">
        <p class="text-left font-medium">{e.datetime.split(' ')[0]}<br/>{e.datetime.split(' ')[1]}</p></td>
      <td class="ant-table-cell"><p class="text-left font-medium">{e.location}<br/>{e.description}</p></td></tr>
   ))}
   {!d.vietlight_events ? "" : d.vietlight_events.map( e => (
	<tr class="ant-table-row ant-table-row-level-0">
      <td class="ant-table-cell">
        <p class="text-left font-medium">{e.datetime}</p></td>
      <td class="ant-table-cell"><p class="text-left font-medium">{e.location}<br/>{e.description}</p></td></tr>
   ))}
   

</tbody></table></div>

</div>
</div>
</div>
</div>
</div>
</div>
<div class="flex w-full items-center justify-between bg-Main_Color_3 p-2 max-md:flex-col">
  <div class="flex items-center justify-start max-md:w-full">
    <img src="/wp-content/uploads/2024/02/Final-Logo-VietLight-2-02-Sao-chep.jpg" />
      <p class="pl-4 text-15"><span class="font-medium">Tracking order - One touch ease</span><br />Tracking, contact shipper, line management money</p>
	</div>
      <a target="_blank" href="https://apps.apple.com/vn/app/vietlight-global/id6479743095">
        <button class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 disabled:opacity-50 dark:focus:ring-slate-400 disabled:pointer-events-none dark:focus:ring-offset-slate-900 data-[state=open]:bg-slate-100 dark:data-[state=open]:bg-slate-800 h-10 py-2 px-4 text-nhattin max-md:mt-2 max-md:w-full">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 h-4 w-4">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg> 
Download App
              </button></a></div>
</div></div></div></div></div></div>
        
        ))}
		
    </div>
  );
}

export default App;

